import axios from "axios";
import { message } from 'antd';
import { WALLET_TYPE_NAME } from '@/utils/settings';
import { map, getQueryString } from '@/utils/tools';
import { formatDate } from '@/utils/format';

const baseReq = axios.create({
  baseURL: '/wallet-manage/public/api/v1',
  timeout: 5000,
});
baseReq.interceptors.response.use(res => {
  if (res.data.code === 0) {
    return res.data.data;
  } else {
    message.error(res.data.msg);
    return Promise.reject(res.data.msg);
  }
});

const convertFenToYuan = fen => fen / 100;
const convertYuanToFen = yuan => parseInt(yuan * 100 || 0);

const formatWallet = wallet => ({
  ...wallet,
  amtAlready: convertFenToYuan(wallet.amtAlready),
  amtOnWay: convertFenToYuan(wallet.amtOnWay),
  amtWithdraw: convertFenToYuan(wallet.amtWithdraw),
  balance: convertFenToYuan(wallet.balance),
  title: WALLET_TYPE_NAME[wallet.businessType],
  rechargeble: wallet.businessType === 'WX_RED_PACKET',
  showAmtAlready: wallet.businessType !== 'WX_RED_PACKET'
});

/**
 * 获取钱包列表
 */
export const getWalletList = () => {
  return baseReq.get("/wallets/my").then(map(formatWallet));
};

/**
 * 获取某个钱包的详细信息 包括提现记录等
 * @param {*} biztype 
 */
export const getWithdrawOverview = biztype => {
  return baseReq.get('/wallet/withdraw/overview', {
    params: {
      biztype,
    }
  });
}

/**
 * 发起提现
 * @param {*} bankno 银行卡号
 * @param {*} biztype 业务类型
 * @param {*} paytype 打款方式
 * @param {*} totalfee 提现金额（单位分）
 */
export const postWithdraw = ({
  biztype = getQueryString('biztype'), 
  bankno, 
  paytype = 'BANK_SERVICE', 
  totalfee
}) => {
  if (!(biztype && bankno && paytype && totalfee !== undefined)) {
    console.warn('some args needed by postWithdraw');
    return;
  }

  const formData = new FormData();
  formData.append('biztype', biztype);
  formData.append('bankno', bankno);
  formData.append('paytype', paytype);
  formData.append('totalfee', convertYuanToFen(totalfee));

  return baseReq.post('/wallet/withdraw/action', formData);
}

/**
 * 获取用户银行卡列表
 */
export const getBankCards = () => {
  return baseReq.get('/bank/cards');
}

/**
 * 新增银行卡
 */
export const addBankCards = ({
  bankAccountNo,
  bankBranchName,
  bankName,
  certName,
  certNo,
  city,
  phone,
  province,
}) => {

  if (!(
    bankAccountNo && 
    bankBranchName &&
    bankName &&
    certName &&
    certNo &&
    city &&
    phone &&
    province
  )) {
    console.warn('some args needed by addBankCards');
    return;
  }

  const formData = new FormData();
  
  formData.append('bankAccountNo', bankAccountNo);
  formData.append('bankBranchName', bankBranchName);
  formData.append('bankName', bankName);
  formData.append('certName', certName);
  formData.append('certNo', certNo);
  formData.append('city', city);
  formData.append('phone', phone);
  formData.append('province', province);

  return baseReq.post('/bank/cards', formData);
}

/**
 * 设定默认提现银行卡
 * @param {*} bankAccountNo 银行卡号
 */
export const setDefaultBankCard = (bankAccountNo) => {
  return baseReq.put(`/bank/default?bankAccountNo=${bankAccountNo}`);
}

/**
 * 获取默认提现银行卡
 */
export const getDefaultBankCard = () => {
  return baseReq.get(`/bank/default`);
}

const formatOrder = order => ({
  ...order,
  totalFee: convertFenToYuan(order.totalFee),
  ctime: formatDate((new Date(order.ctime).toLocaleDateString()))
})

/**
 * 钱包订单
 * @param {*} biztype 
 */
export const getWalletOrders = (offset = 0, biztype = getQueryString('biztype')) => {
  return baseReq.get(`/wallets/orders`, {
    params: {
      biztype,
      limit: 10,
      offset,
    }
  }).then(data => {
    return {
      ...data,
      tradingRecords: map(formatOrder)(data.tradingRecords)
    }
  });
}

/**
 * 获取提现订单列表
 * @param {*} biztype 
 */
export const getWithdrawList = (offset = 0, biztype = getQueryString('biztype')) => {
  return baseReq.get(`/wallet/withdraw/list`, {
    params: {
      biztype,
      limit: 10,
      offset,
    }
  }).then(data => {
    return {
      ...data,
      withdrawOrders: map(formatOrder)(data.withdrawOrders)
    }
  });
}